/**
 * @generated SignedSource<<a52041e437007bf436a4536643ba3141>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "kind": "InlineDataFragment",
  "name": "readingHistoryActionMenuSocialButtonArticle"
};
node.hash = "f4c88864c5a03b3f32c07b9080058e99";
export default node;